var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaritimoBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921,
    height: 617,
    viewBox: "0 0 1921 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2074.98 355.641C2080.17 360.807 2085.35 366.002 2090.48 371.244L1703.83 811.017C1700.46 807.582 1697.08 804.176 1693.67 800.798L2074.98 355.641Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2043.35 325.049C2048.68 330.073 2053.98 335.126 2059.25 340.226L1683.37 790.702C1679.93 787.361 1676.46 784.05 1672.97 780.766L2043.35 325.049Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2010.99 295.34C2016.44 300.213 2021.85 305.124 2027.25 310.073L1662.42 770.957C1658.9 767.72 1655.35 764.503 1651.78 761.314L2010.99 295.34Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1977.89 266.537C1983.45 271.24 1988.98 275.99 1994.47 280.769L1640.96 751.777C1637.37 748.645 1633.75 745.541 1630.12 742.457L1977.89 266.537Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1944.44 238.949C1950.12 243.501 1955.75 248.09 1961.37 252.726L1619.3 733.424C1615.63 730.396 1611.94 727.387 1608.23 724.416L1944.44 238.949Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1910.32 212.279C1916.11 216.679 1921.88 221.127 1927.62 225.612L1597.22 715.687C1593.47 712.754 1589.71 709.849 1585.91 706.972L1910.32 212.279Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1875.15 186.273C1881.04 190.503 1886.89 194.771 1892.72 199.086L1574.4 698.349C1570.6 695.519 1566.77 692.728 1562.93 689.965L1875.15 186.273Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1839.31 161.246C1845.3 165.315 1851.26 169.412 1857.2 173.566L1551.19 681.667C1547.31 678.951 1543.41 676.264 1539.5 673.615L1839.31 161.246Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1802.96 137.293C1809.03 141.182 1815.09 145.118 1821.12 149.093L1527.63 665.672C1523.68 663.07 1519.73 660.505 1515.75 657.969L1802.96 137.293Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1766.1 114.422C1772.3 118.15 1778.47 121.916 1784.61 125.729L1503.77 650.418C1499.76 647.929 1495.73 645.469 1491.69 643.037L1766.1 114.422Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1728.64 92.5684C1734.93 96.1168 1741.21 99.7219 1747.45 103.365L1479.52 635.822C1475.45 633.447 1471.37 631.1 1467.25 628.773L1728.64 92.5684Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1690.59 71.7461C1696.98 75.1242 1703.32 78.5496 1709.67 82.0128L1454.88 621.898C1450.75 619.636 1446.6 617.403 1442.45 615.208L1690.59 71.7461Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1652.1 52.0449C1658.56 55.2338 1665 58.4793 1671.41 61.7628L1429.94 608.697C1425.76 606.549 1421.57 604.439 1417.36 602.357L1652.1 52.0449Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1613.2 33.4688C1619.72 36.4683 1626.22 39.5247 1632.71 42.6094L1404.71 596.215C1400.5 594.199 1396.26 592.212 1392.01 590.254L1613.2 33.4688Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1573.77 15.9629C1580.38 18.7827 1586.97 21.6592 1593.54 24.5737L1379.2 584.462C1374.93 582.56 1370.64 580.696 1366.34 578.851L1573.77 15.9629Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1533.96 -0.392569C1540.61 2.22851 1547.26 4.90636 1553.87 7.62206L1353.37 573.425C1349.07 571.655 1344.75 569.914 1340.42 568.211L1533.96 -0.392569Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1493.66 -15.6484C1500.38 -13.2166 1507.08 -10.728 1513.78 -8.19208L1327.27 563.127C1322.92 561.481 1318.55 559.863 1314.18 558.273L1493.66 -15.6484Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1453.47 -29.5918C1460.25 -27.3492 1467 -25.0593 1473.76 -22.7126L1301.23 553.678C1296.84 552.155 1292.44 550.669 1288.03 549.203L1453.47 -29.5918Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1412.54 -42.5234C1419.36 -40.4701 1426.17 -38.3789 1432.96 -36.2215L1274.68 544.882C1270.26 543.491 1265.83 542.119 1261.38 540.794L1412.54 -42.5234Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1371.31 -54.2773C1378.22 -52.4132 1385.11 -50.5019 1391.99 -48.5431L1248 536.875C1243.53 535.597 1239.04 534.348 1234.55 533.137L1371.31 -54.2773Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1329.67 -64.8867C1336.61 -63.2308 1343.52 -61.5181 1350.43 -59.7581L1220.95 529.568C1216.45 528.423 1211.95 527.306 1207.44 526.228L1329.67 -64.8867Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1287.95 -74.2695C1294.9 -72.8123 1301.84 -71.3078 1308.76 -69.7465L1193.81 523.062C1189.29 522.049 1184.78 521.065 1180.25 520.109L1287.95 -74.2695Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1246.17 -82.4355C1253.17 -81.177 1260.15 -79.8618 1267.12 -78.4897L1166.67 517.356C1162.13 516.466 1157.58 515.615 1153.01 514.792L1246.17 -82.4355Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1204.19 -89.4219C1211.23 -88.3526 1218.26 -87.2361 1225.27 -86.0722L1139.37 512.423C1134.8 511.656 1130.22 510.928 1125.62 510.237L1204.19 -89.4219Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.9 -95.2383C1168.96 -94.3677 1176.02 -93.4499 1183.07 -92.4753L1111.83 508.234C1107.22 507.6 1102.61 507.004 1097.99 506.427L1161.9 -95.2383Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1119.6 -99.8437C1126.64 -99.1719 1133.67 -98.4622 1140.7 -97.6958L1084.13 504.821C1079.52 504.329 1074.93 503.856 1070.32 503.42L1119.6 -99.8437Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1077.19 -103.262C1084.24 -102.789 1091.28 -102.278 1098.31 -101.7L1056.38 502.198C1051.76 501.829 1047.15 501.488 1042.53 501.176L1077.19 -103.262Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1034.82 -105.484C1041.88 -105.21 1048.92 -104.898 1055.97 -104.519L1028.6 500.353C1023.98 500.107 1019.35 499.899 1014.72 499.719L1034.82 -105.484Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M992.39 -106.529C999.437 -106.454 1006.48 -106.331 1013.51 -106.151L1000.7 499.28C996.072 499.167 991.441 499.081 986.801 499.034L992.39 -106.529Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949.98 -106.395C957.037 -106.518 964.102 -106.585 971.176 -106.604L972.819 498.979C968.153 498.998 963.505 499.045 958.856 499.121L949.98 -106.395Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.594 -105.088C914.659 -105.4 921.724 -105.675 928.798 -105.883L944.923 499.453C940.266 499.595 935.626 499.775 930.986 499.983L907.594 -105.088Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.137 -102.588C872.193 -103.099 879.25 -103.572 886.324 -103.979L917.019 500.705C912.379 500.979 907.748 501.282 903.125 501.623L865.137 -102.588Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.781 -98.9016C829.829 -99.6207 836.877 -100.283 843.942 -100.889L889.233 502.735C884.611 503.132 879.997 503.568 875.384 504.031L822.781 -98.9016Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M780.402 -94.0144C787.432 -94.9228 794.471 -95.7839 801.519 -96.5977L861.468 505.54C856.863 506.07 852.258 506.638 847.662 507.234L780.402 -94.0144Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M738.172 -87.9281C745.184 -89.0352 752.206 -90.0949 759.227 -91.1074L833.833 509.129C829.246 509.782 824.659 510.482 820.081 511.21L738.172 -87.9281Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M696.117 -80.6526C703.103 -81.9584 710.098 -83.2169 717.102 -84.4375L806.331 513.49C801.761 514.275 797.201 515.098 792.649 515.95L696.117 -80.6526Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M654.266 -72.187C661.217 -73.6915 668.176 -75.1487 675.145 -76.5586L778.979 518.625C774.436 519.542 769.893 520.489 765.367 521.473L654.266 -72.187Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.629 -62.5342C619.545 -64.2374 626.469 -65.8933 633.412 -67.502L751.78 524.521C747.263 525.571 742.755 526.65 738.247 527.757L612.629 -62.5342Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.238 -51.7018C578.119 -53.6037 585 -55.4583 591.907 -57.2656L724.749 531.19C720.258 532.363 715.768 533.574 711.295 534.814L571.238 -51.7018Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.867 -39.9192C537.695 -42.0103 544.532 -44.0542 551.377 -46.0508L698.367 538.487C693.912 539.793 689.457 541.118 685.019 542.48L530.867 -39.9192Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.473 -26.9028C497.248 -29.1927 504.032 -31.4258 510.842 -33.6211L671.98 546.583C667.551 548.012 663.131 549.469 658.729 550.955L490.473 -26.9028Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.082 -12.6303C456.796 -15.1094 463.518 -17.5413 470.267 -19.9258L645.579 555.5C641.186 557.052 636.809 558.632 632.433 560.241L450.082 -12.6303Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.023 2.79097C416.676 0.122577 423.345 -2.4985 430.033 -5.07226L619.388 565.159C615.038 566.834 610.697 568.546 606.364 570.278L410.023 2.79097Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.176 19.4307C376.758 16.573 383.357 13.7627 389.983 10.9902L593.319 575.619C589.004 577.427 584.707 579.253 580.419 581.117L370.176 19.4307Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.844 37.1533C337.347 34.1064 343.876 31.1163 350.422 28.1641L567.555 586.804C563.293 588.724 559.04 590.674 554.804 592.661L330.844 37.1533Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.914 56.0124C298.347 52.7857 304.797 49.6064 311.273 46.4648L542.053 598.717C537.835 600.771 533.625 602.843 529.434 604.943L291.914 56.0124Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.543 75.9309C259.888 72.5245 266.259 69.1653 272.647 65.8535L516.88 611.35C512.715 613.517 508.567 615.703 504.428 617.926L253.543 75.9309Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.613 96.9658C221.879 93.3795 228.171 89.8312 234.48 86.3301L492 624.711C487.879 626.991 483.775 629.309 479.689 631.647L215.613 96.9658Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.277 119.029C184.455 115.263 190.65 111.544 196.881 107.863L467.459 638.759C463.399 641.162 459.357 643.594 455.323 646.045L178.277 119.029Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.422 142.19C147.494 138.254 153.601 134.355 159.726 130.504L443.214 653.537C439.216 656.053 435.235 658.599 431.263 661.163L141.422 142.19Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.199 166.349C111.175 162.243 117.185 158.174 123.214 154.152L419.364 668.981C415.427 671.602 411.508 674.261 407.606 676.948L105.199 166.349Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.625 191.488C75.4863 187.221 81.3828 183.001 87.2968 178.818L395.899 685.093C392.033 687.828 388.184 690.591 384.352 693.382L69.625 191.488Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5898 217.692C40.3633 213.254 46.1631 208.854 51.9893 204.492L372.824 701.882C369.01 704.73 365.223 707.607 361.444 710.512L34.5898 217.692Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.238281 244.843C5.89748 240.254 11.5831 235.693 17.2862 231.18L350.133 719.334C346.399 722.286 342.682 725.257 338.973 728.266L0.238281 244.843Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.4102 272.934C-27.8828 268.194 -22.3202 263.481 -16.7313 258.816L327.874 737.414C324.218 740.47 320.58 743.545 316.96 746.649L-33.4102 272.934Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-66.3438 301.942C-60.9218 297.041 -55.4735 292.168 -49.9901 287.342L306.109 756.079C302.524 759.24 298.947 762.429 295.406 765.636L-66.3438 301.942Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-98.543 331.852C-93.2441 326.799 -87.9276 321.794 -82.5671 316.816L284.78 775.372C281.274 778.627 277.785 781.911 274.323 785.223L-98.543 331.852Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-130 362.645C-124.815 357.441 -119.596 352.265 -114.349 347.127L263.974 795.227C260.529 798.586 257.119 801.974 253.727 805.39L-130 362.645Z",
    fill: "#F9F9F9",
    fillOpacity: 0.05
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaritimoBg);
export default __webpack_public_path__ + "static/media/maritimo-bg.9d6c4f8778740aa16c71a073d2b87a2f.svg";
export { ForwardRef as ReactComponent };